import React, { useEffect, useState, useContext } from "react";
import Header from "./components/Header";
import StripeForm from "./components/StripeForm";
import EmailStepComponent from "./components/EmailStepComponent";
import ChargeComponent from "./components/ChargeComponent";
import Infos from "./components/Infos";
import ProtectedRoute from "./components/ProtectedRoute";
import StartChargingComponent from "./components/StartChargingComponent";
import ConnectorsComponent from "./components/ConnectorsPlugComponent";
import ResumeSessionComponent from "./components/ResumeSessionComponent";
import SessionChoiceComponent from "./components/SessionChoiceComponent";
import SessionLinkComponent from "./components/SessionLinkComponent";
import ConnectorBusyComponent from "./components/ConnectorBusyComponent";
import ErrorComponent from "./components/ErrorComponent";
import HeaderSyder from "./components/HeaderSyder";
import Footer from "./components/Footer";
import { PartnerProvider, PartnerContext } from "./context/PartnerContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useSearchParams,
  useParams,
} from "react-router-dom";
import "./PaymentStyles.css";

// `bare` : écrans de la refonte Scan to Charge, qui portent leur propre en-tête
// (logo Qovoltis ou Syder) via ScreenLayout.
const Layout = ({ children, bare = false }) => {
  const { partner } = useContext(PartnerContext);
  const isSyder = partner === "SYDER";

  if (bare) return children;

  return (
    <>
      {isSyder ? <HeaderSyder /> : <Header />}
      {children}
      {isSyder && <Footer />}
    </>
  );
};

const PartnerInitializer = ({ children }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { ref } = useParams();
  const { setPartner } = useContext(PartnerContext);

  useEffect(() => {
    const isRefPage = /^\/[^/]+$/.test(location.pathname);
    if (isRefPage) {
      const partnerParam = searchParams.get("partner");

      if (partnerParam) {
        localStorage.setItem("partner", partnerParam);
        setPartner(partnerParam);
      } else {
        localStorage.removeItem("partner");
        setPartner(null);
      }
    }
  }, [location.key]);

  return children;
};

function App() {
  return (
    <PartnerProvider>
      <Router>
        <Routes>
          <Route path="/:ref"
            element={
              <PartnerInitializer>
                <Layout bare>
                  <ChargeComponent />
                </Layout>
              </PartnerInitializer>
            }
          />
          <Route path="/email"
            element={
              <Layout bare>
                <ProtectedRoute>
                  <EmailStepComponent />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route path="/payment"
            element={
              <Layout bare>
                <ProtectedRoute>
                  <StripeForm />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route path="/infos"
            element={
              <Layout>
                <Infos />
              </Layout>
            }
          />
          <Route path="/start-charging"
            element={
              <Layout bare>
                <StartChargingComponent />
              </Layout>
            }
          />
          <Route path="/connectors/:ref"
            element={
              <Layout bare>
                <ConnectorsComponent />
              </Layout>
            }
          />
          <Route path="/busy"
            element={
              <Layout bare>
                <ConnectorBusyComponent />
              </Layout>
            }
          />
          <Route path="/session-choice"
            element={
              <Layout bare>
                <SessionChoiceComponent />
              </Layout>
            }
          />
          <Route path="/resume-session"
            element={
              <Layout bare>
                <ResumeSessionComponent />
              </Layout>
            }
          />
          <Route path="/sessions/:sessionToken/resume"
            element={
              <Layout bare>
                <SessionLinkComponent />
              </Layout>
            }
          />
          <Route path="/error"
            element={
              <Layout bare>
                <ErrorComponent />
              </Layout>
            }
          />
          <Route path="*"
            element={
              <Navigate
                to="/error"
                replace
                state={{ notFound: true }}
              />
            }
          />
        </Routes>
      </Router>
    </PartnerProvider>
  );
}

export default App;
